module.exports = __webpack_public_path__ + "img/es.b72034bb.svg";